<script>
import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE } from '@common/store/module-types'
import { mapActions } from 'vuex'

export default {
    name: 'HcObjectPicker',
    props: {
        value: {
            type: [String, Boolean, Number],
        },
        row: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            objectLoading: false,
            objectArr: [],
        }
    },
    
    mounted() {
        this.getObjectList()
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getObject: T.GET_NEW_OBJECT,
        }),

        async getObjectList(keyword) {
            this.objectLoading = true
            try {
                const resData = await this.getObject({
                    keyword,
                    page: 1,
                    pageSize: 20,
                })
                this.objectArr = resData.items || []
                this.objectLoading = false
            } catch (error) {
                this.objectLoading = false
            }
        },

        emitEvent(type, value) {
            this.$emit(type, value)
        },
    },

    render() {
        const Options = this.objectArr.map(item => <hc-option key={item.id} label={item.title} value={item.id} />)
        const that = this
        const on = {
            change: value => { this.emitEvent('change', value) },
            input: value => { this.emitEvent('input', value) },
            clear: () => {
                if (that.$refs.select) {
                    that.$refs.select.focus()
                }
                this.emitEvent('change', '')
                this.getObjectList()
            },
        }
        return (
            <hc-select value={this.value} placeholder="请选择关联对象" ref="select"
                filterable
                remote
                clearable
                no-data-text="暂无数据"
                no-match-text="暂无搜索结果"
                popper-class="add-object-content__select"
                loading={this.objectLoading}
                remote-method={this.getObjectList}
                on={on}
            >
                {Options}
            </hc-select>
        )
    },
}
</script>
